export const LoginRule = {
  "validateTelephony":"validateTelephony",
  };


// WEBPACK FOOTER //
// ./src/BusinessRule/LoginRule.js